import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Placeholder from 'components/consumer/Placeholder';
import BrowserOnly from 'components/consumer/BrowserOnly';
const AFFIRM_LINE_HEIGHT = '23px';
const PDPFinancingUI = t0 => {
  const $ = _c(10);
  const {
    affirmButtonRef,
    isAffirmContentReady: t1,
    loading,
    onAffirmClick,
    pdpIsModularBYOProduct: t2,
    price
  } = t0;
  const isAffirmContentReady = t1 === undefined ? false : t1;
  const pdpIsModularBYOProduct = t2 === undefined ? false : t2;
  let t3;
  if ($[0] !== onAffirmClick) {
    t3 = event => {
      const link = event.target.closest?.("a, button");
      if (link) {
        onAffirmClick?.(link.textContent?.trim());
      }
    };
    $[0] = onAffirmClick;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const handleClick = t3;
  if (loading) {
    let t4;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <div className="flex mt-1 lg:mt-1.5 !w-full lg:!w-[310px]"><Placeholder type="rect" loading={true} className="rounded-sm min-h-[12px]" style={{
          height: AFFIRM_LINE_HEIGHT,
          marginRight: "0"
        }} /></div>;
      $[2] = t4;
    } else {
      t4 = $[2];
    }
    return t4;
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      minHeight: AFFIRM_LINE_HEIGHT
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== affirmButtonRef || $[5] !== handleClick || $[6] !== isAffirmContentReady || $[7] !== pdpIsModularBYOProduct || $[8] !== price) {
    t5 = <div className="flex mt-1 lg:mt-1.5" style={t4}>{pdpIsModularBYOProduct && !price ? <span className="text-xs flex text-gray mt-0 mr-2 mb-0 ml-0">Start adding pieces to calculate price + financing options</span> : <BrowserOnly><div ref={affirmButtonRef} onClick={handleClick} className={classNames("affirm-as-low-as text-[13px] min-w-0", {
          invisible: !isAffirmContentReady
        })} data-page-type="product" data-amount={(price * 100).toString()} /></BrowserOnly>}</div>;
    $[4] = affirmButtonRef;
    $[5] = handleClick;
    $[6] = isAffirmContentReady;
    $[7] = pdpIsModularBYOProduct;
    $[8] = price;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};
PDPFinancingUI.propTypes = {
  affirmButtonRef: PropTypes.object,
  isAffirmContentReady: PropTypes.bool,
  loading: PropTypes.bool,
  onAffirmClick: PropTypes.func,
  pdpIsModularBYOProduct: PropTypes.bool,
  price: PropTypes.number
};
export default PDPFinancingUI;